export default from './NotFound.js';



// WEBPACK FOOTER //
// ./src/components/Errors/NotFound/index.js